import React from 'react';

function PainExtractorHero({
  searchType,
  setSearchType,
  subredditUrl,
  setSubredditUrl,
  numberOfPosts,
  setNumberOfPosts,
  postUrl,
  setPostUrl,
  handleSearch,
  loading,
  handleFocus,
}) {
  const isPostMode = searchType === 'post';

  const handleToggle = () => {
    setSearchType(isPostMode ? 'subreddit' : 'post');
  };

  const postNumberOptions = Array.from({ length: 15 }, (_, i) => i + 1);

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[var(--color-primary-accent)] via-[#1A535C] to-[var(--color-secondary-accent)] text-white p-4 py-6 md:p-12 md:pb-2 mb-10 shadow-2xl shadow-primary/20 flex flex-col justify-center">
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4">Extract Customer Pains</h1>
        <p className="text-xl md:text-2xl max-w-5xl mx-auto text-white/90 leading-relaxed mt-6 mb-8">
          WizeHelper’s AI analyzes Reddit conversations to reveal customer needs, frustrations, and untapped opportunities for your next business move.
        </p>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 pt-6 pb-1 px-8 rounded-xl max-w-5xl mx-auto" data-testid="painExtractor-formContainer">
          <form onSubmit={handleSearch}>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
              <button
                type="button"
                onClick={handleToggle}
                className={`w-full bg-transparent border-none rounded-md px-6 py-3 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition-all hover:scale-105 active:scale-95 duration-200 flex items-center justify-center gap-2 ${isPostMode ? 'bg-white/20' : 'bg-white/10'}`}
                data-testid="painExtractor-searchTypeToggleButton"
                title={isPostMode ? "Switch to Subreddit Search" : "Switch to Single Post Search"}
              >
                <span className="material-symbols-outlined text-white/50">
                  {isPostMode ? 'forum' : 'post_add'}
                </span>
                {isPostMode ? 'Subreddit' : 'Post'}
              </button>

              {isPostMode ? (
                <>
                  <div className="relative md:col-span-2">
                    <label htmlFor="pain-extractor-post-url" className="sr-only">Reddit Post URL</label>
                    <input
                      id="pain-extractor-post-url"
                      name="pain-extractor-post-url"
                      type="text"
                      value={postUrl}
                      onFocus={handleFocus}
                      onChange={(e) => setPostUrl(e.target.value)}
                      placeholder="Enter Post URL"
                      required
                      className="w-full bg-transparent border-none rounded-md pl-12 pr-4 py-4 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition"
                      aria-label="Reddit post URL"
                      data-testid="painExtractor-postUrlInput"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="relative">
                    <label htmlFor="pain-extractor-subreddit-url" className="sr-only">Subreddit URL</label>
                    <input
                      id="pain-extractor-subreddit-url"
                      name="pain-extractor-subreddit-url"
                      type="text"
                      value={subredditUrl}
                      onFocus={handleFocus}
                      onChange={(e) => setSubredditUrl(e.target.value)}
                      placeholder="Enter Subreddit or URL"
                      required
                      className="w-full bg-transparent border-none rounded-md pl-12 pr-4 py-4 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition"
                      aria-label="Reddit subreddit URL"
                      data-testid="painExtractor-subredditInput"
                    />
                  </div>
                  <div className="relative">
                    <select
                      value={numberOfPosts}
                      onChange={(e) => setNumberOfPosts(parseInt(e.target.value))}
                      className="w-full bg-transparent border border-[var(--color-border-subtle)] rounded-md pl-4 pr-10 py-3 text-white focus:ring-2 focus:ring-[var(--color-primary-accent)] transition appearance-none text-center hover:bg-white/10"
                      aria-label="Number of posts to fetch"
                      data-testid="painExtractor-numberOfPostsDropdown"
                    >
                      {postNumberOptions.map((num) => (
                        <option key={num} value={num} className="bg-[#1A535C] text-white">
                          {num} Posts
                        </option>
                      ))}
                    </select>
                    <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-white/50 text-xl pointer-events-none">arrow_drop_down</span>
                  </div>
                </>
              )}

              <button type="submit" disabled={loading} className="w-full bg-[var(--color-primary-accent)] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[var(--color-secondary-accent)] transition-transform shadow-lg" data-testid="painExtractor-searchButton">
                {loading ? <div className="spinner"></div> : (
                  <span className="flex items-center justify-center gap-2">
                    <span className="material-symbols-outlined">auto_awesome</span>
                    Find
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="mt-4 text-center relative z-10">
        <p className="text-white/70 text-xs mb-2 leading-relaxed">
          This service analyzes publicly available Reddit content. Usage is subject to
          <a href="https://www.redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white mx-1">Reddit's API Terms</a>
          and our
          <a href="/privacy-policy" className="underline hover:text-white mx-1">Privacy Policy</a>.
          <br />
        </p>
      </div>
    </div>
  );
}

export default PainExtractorHero;
